<link href="https://cdn.syncfusion.com/ej2/material.css" rel="stylesheet" />
<!-- TODO: Host this CSS in the project? -->
<div *ngIf="viewSingle && isTrialUser" class="blurScreen"></div>
<h2 class="text-center">Quartermaster & Ordnance Specification<span *ngIf="!viewSingle">s</span></h2>
<div *ngIf="listMode" class="container">
	<div class="search_bar">
		<div style="display:inline-block; vertical-align:top; width:25%;">
			<app-qm-search #qmModuleSearch configIcon="fa-ellipsis-v" [searchText]="searchQMTerm" maxResults="5"
				(searchOutput)="quickFilterData($event)" (resultsOutput)="searchDataResults($event)"
				(errorOutput)="searchError($event)"></app-qm-search>
		</div>
		<!-- TODO: We can probably shift all pagination responsibilities to the StarbasePaginationComponent -->
		<div class="pagination_bar noselect"
			style="display:inline-block; position:relative; bottom:10px; text-align:center; min-width: 500px; width:45%;">
			<div class="pagination_widget" style="position: absolute; left: 15%;">
				<div class="pagination_btn pagination_btn_background" (click)="movePage(-1000)"
					title="Move to first page">
					<i id="goToFirstPage" class="fal fa-angle-double-left icon_style" style="right:2px;"></i>
				</div>
				<div class="pagination_btn pagination_btn_background" (click)="movePage(-1)"
					title="Move to previous page">
					<i id="goToPreviousPage" class="fal fa-angle-left icon_style" style="right:15px;"></i>
				</div>
				<div class="pagination_btn page_indicator noselect">
					<span style="position:relative; top:2px; cursor: default;">
						Showing {{ (startIndex + 1) }} - {{ (endIndex < allItemsCount ? endIndex : allItemsCount) }} out
							of {{ allItemsCount }} </span>
				</div>
				<div class="pagination_btn pagination_btn_background" (click)="movePage(1)" title="Move to next page">
					<i id="goToNextPage" class="fal fa-angle-right icon_style" style="left:15px;"></i>
				</div>
				<div class="pagination_btn pagination_btn_background" (click)="movePage(1000)"
					title="Move to last page">
					<i id="goToLastPage" class="fal fa-angle-double-right icon_style" style="left:5px;"></i>
				</div>
			</div>

		</div>
		<div style="display:inline-block; vertical-align:top; min-width: 200px; width:25%; text-align:left;">
			<span style="font-size: 19px;">up to</span>&nbsp;
			<select title="Entries per page" (change)="calculatePaginationIndices(); retrieve();"
				[(ngModel)]="itemsPerPage" style="cursor:pointer; height: 32px; font-size: 1rem;">
				<option value="10">10 at a time</option>
				<option value="15">15 at a time</option>
				<option value="20">20 at a time</option>
				<option value="25">25 at a time</option>
				<option value="30">30 at a time</option>
				<option value="35">35 at a time</option>
			</select>

		</div>
	</div>

	<div style="width:100%; text-align: left; z-index:98;">

		&nbsp; &nbsp; <i class="fas fa-spinner fa-spin" id="searchWait"
			style="position:relative; display: none; color:#000"></i>
	</div>
	<table class="content_table">
		<thead>
			<tr>
				<!-- <th>UID</th> -->
				<th matTooltip="Sort by Item Name" (click)="sortClick('itemName')" style="padding-left: 5px; min-width: 110px;">
					Item Name 
					<i *ngIf="itemNameSortDirection === 0"
						class="fas fa-sort ms-1"></i>
					<i *ngIf="itemNameSortDirection == 1" 
						class="fas fa-sort-up ms-1"></i>
					<i *ngIf="itemNameSortDirection == -1" 
						class="fas fa-sort-down ms-1"></i> 
				</th>
				<th style="cursor:auto">
					Specification Text
				</th>
				<th matTooltip="Sort by Source Reference" (click)="sortClick('sourceReference')">
					Source Reference 
					<i *ngIf="sourceReferenceSortDirection === 0"
						class="fas fa-sort ms-1"></i>
					<i *ngIf="sourceReferenceSortDirection == 1" 
						class="fas fa-sort-up ms-1"></i>
					<i *ngIf="sourceReferenceSortDirection == -1"
						 class="fas fa-sort-down ms-1"></i>
				</th>
				<th>
					<div *ngIf="canEdit" class="lebtn pagination_btn_background add_new_button"
						(click)="addEntryActivate(true)">
						<i class="fa fa-plus-circle"></i> Add new item
					</div>
				</th>
				<!--
				<th title='Sort by Specification Category' (click)='sortClick("specificationCategoryUID")'>
				  Specification Category <i *ngIf='specificationCategorySortDirection == 1' id='icone' class="fas fa-sort-up" style='position: relative; top: 5px;'></i> <i *ngIf='specificationCategorySortDirection == -1' id='icone' class="fas fa-sort-down" style='position: relative;'></i>
				</th>
				-->
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let manual of data; let i=index" class="entry" (click)="enterViewMode(manual.uid)">
				<!-- <td *ngIf='i >= startIndex && i < endIndex '>{{ manual.uid }}</td> -->
				<td style="padding: 5px;" *ngIf="isInCurrentPage(manual.uid)"><b>{{ manual.itemName }}</b></td>
				<td *ngIf="isInCurrentPage(manual.uid)">{{ truncateString(manual.saniSpecifications, 80, true) }}</td>
				<td *ngIf="isInCurrentPage(manual.uid)">{{ getSourceReferenceName(manual.sourceReferenceUID) }}</td>
				<!--
				<td *ngIf='i >= startIndex && i < endIndex '>{{ getSpecificationCategory(manual.specificationCategoryUIDs )  }}</td>
			    -->
				<td *ngIf="isInCurrentPage(manual.uid)"></td>
			</tr>
		</tbody>
	</table>
</div>


<!-- TODO: The following sections should be a separate component and not coupled with the table listing view. -->
<div *ngIf="addMode" class="container">
	<div *ngIf="isAdmin || loggedInUser.isInUserGroup('Librarian')" class="btn-group editButtonsBar" role="group">

		<app-slant-button btnColor="green" [disabled]="!isSaveable()" (click)="saveQMSpecification()"
			tooltip="Save changes" btnIconClass="fa-save">{{ isLoading ? 'Please wait...' : 'Save' }}</app-slant-button>

		<app-slant-button btnColor="yellow" (click)="enterViewMode(model.uid,true)" tooltip="Cancel changes"
			[disabled]="isLoading" btnIconClass="fa-undo" style="border-radius:0">Cancel</app-slant-button>

		<app-slant-button btnColor="red" *ngIf="model.uid !== 0 && isAdmin"
			[disabled]="isLoading || (relatedImages && relatedImages.length > 0)" tooltip="Delete record"
			(click)="deleteQM(model.uid)" btnIconClass="fa-trash">Delete</app-slant-button>
	</div>

	<table class="singleViewTable"
		style="margin:auto; margin-top:60px; margin-bottom: 50px; min-width:400px">
		<tbody>
			<tr>
				<td style="width:100%" >
					<div style="width:40%; display:inline-block">
						<label>Item Name *</label>
					</div>
					<div style="width:59%; display:inline-block">
						<input type="text" [(ngModel)]="model.itemName" maxlength="255"
							placeholder="Enter the item name"
							style="height:30px; background-color: #fff; border:1px solid #c0c0c0; border-radius:5px; width:100%" />
					</div>
				</td>
			</tr>
			<tr>
				<td >
					<div style="width:40%; display:inline-block">
						<label>Source Reference *</label>
					</div>
					<div style="width:59%; display:inline-block; margin-bottom:15px;">
						<div class="component-holder" style="margin-top: 5px; margin-bottom: 20px; width:100%">
							<app-starbase-dropdown (selectItemEvent)="setSourceReference($event)"
								[displayLabel]="'Please select a source reference'" [valueField]="'uid'"
								[textField]="'sourceReference'" [selectedValues]="[model.sourceReferenceUID]"
								[dataSource]="sourceReferences"></app-starbase-dropdown>
						</div>
					</div>
				</td>
			</tr>
			<tr>
				<td valign="top" >
					<label>Specification *</label>
				</td>
			</tr>
			<tr>
				<td>
					<div style="margin-bottom: 15px;">
						<ejs-richtexteditor (actionBegin)="handleRTFChanges($event)" [height]="RTFHeight"
							[enableHtmlEncode]="true" [enablePersistence]="false" [(value)]="model.specifications"
							#toolsRTE id="alltoolRTE" [toolbarSettings]="tools" [fontSize]="size"
							[fontFamily]="fontFamilies"></ejs-richtexteditor>

					</div>
				</td>
			</tr>
			<tr>
				<td >
					<label>Specification Categories *</label>
				</td>
			</tr>
			<tr>
				<td style="text-align: left;">
					<div class="component-holder">
						<app-starbase-dropdown (selectItemEvent)="addCategories($event)" [displayLabel]="'Categories'"
							[isMultiSelect]="true" [valueField]="'uid'" [textField]="'specificationCategory'"
							[selectedValues]="getCategoryArrayForEdit()" [dataSource]="specificationCategories">
						</app-starbase-dropdown>
					</div>
					<div class="component-holder" style="margin-top: 5px; margin-bottom: 20px; width:100%;">
						<app-qmcategories-display (removeAction)="removeCategory($event)" [columns]="[]"
							[data]="getCategoriesArray(true)" [isAdmin]="true" [editMode]="true">
						</app-qmcategories-display>
					</div>
				</td>
			</tr>
			<tr style="min-height: 150px;">
				<td valign="top" style="width:49%" >
					<label>Item-to-item references</label>
				</td>
			</tr>
			<tr>
				<td style="width:50%;">
					<div class="component-holder">
						<app-qm-search #qmModuleLinkSearch configIcon="fa-ellipsis-v" maxResults="5"
							(selectedOutput)="addToRefList($event)" allDataDropdown="true" dropDown="true"
							(errorOutput)="searchError($event)"></app-qm-search>
					</div>
					<div class="component-holder" style="margin-top: 5px; width:100%;">
						<app-qmmanuals-display [columns]="[]" (removeAction)="removeQMSpecRef($event)"
							[data]="getRefQMArrays(true)" [isAdmin]="isAdmin || loggedInUser.isInUserGroup('Librarian')"
							[editable]="true">
						</app-qmmanuals-display>
					</div>
				</td>
			</tr>
		</tbody>
	</table>
</div>

<div *ngIf="viewSingle" class="container" style="min-height: 820px;">
	<div style="margin:auto">
		<div style="width:15%; text-align: left; float: left;">
			<app-slant-button class="backBtn" btnColor="bw" style="width: 40px;" leftMode="true"
				(click)="cancelAndGoBack()" tooltip="Navigate back to QM Specs listing" btnIconClass="fa-arrow-alt-circle-left">Go Back</app-slant-button>
		</div>
		<div *ngIf="!isTrialUser"
			style="width:64%; text-align: center; display: inline-block; position: relative; bottom:4px;">
			<div class="btn-group" role="group">
				<app-slant-button [disabled]="viewModel.uid === data[0].uid" leftMode="true" (click)="move(true)" btnColor="red"
					btnIconClass="fa-chevron-left" tooltip="Previous record" style="border-right: 1px solid #ccc;">
					Prev Record
				</app-slant-button>
				<app-slant-button [disabled]="currentPage === maxPage && viewModel.uid === data[data.length - 1].uid" btnColor="blue" (click)="move()" btnIconClass="fa-chevron-right" style="border-left: 1px solid #ccc;" tooltip="Next record">
					Next Record
				</app-slant-button>
			</div>
		</div>
		<div style="width: 20%; display: inline-block; text-align: right;">
			<app-slant-button btnColor="gray" *ngIf="canEdit" (click)="enterEditMode(viewModel.uid);"
				btnIconClass="fa-pencil">Edit Record</app-slant-button>
		</div>
	</div>

	<table class="singleViewTable" style="table-layout: fixed;"> <!-- FIXME: Let's not use a table structure here. This is not tabular data. -->
		<tbody>
			<tr class="tableRow">
				<td style="width:100%;" >
					<div style="width:30%; display: inline-block;"> <!-- Don't use inline-block divs in a table. -->
						<label>Item Name</label>
					</div>
					<div style="width:69%; display: inline-block">
						{{ viewModel.itemName }}
					</div>
				</td>
			</tr>
			<tr class="tableRow">
				<td>
					<div style="width:30%; display: inline-block;">
						<label>Source Reference</label>
					</div>
					<div style="width:69%; display: inline-block;">
						{{ getSourceReferenceName(viewModel.sourceReferenceUID) }}
					</div>
				</td>
			</tr>
      		<tr class="tableRow" style="height: fit-content;">
        		<td>
          			<div style="width: 30%; display: inline-block;">
            			<label>Images with this item</label>
          			</div>
        		</td>
      		</tr>
      		<tr class="tableRow">
        		<td style="padding: 1em;">
          			<app-image-carousel  *ngIf="!this.isLoading" style="width: 99%;"
            		[imageModels]="relatedImages"
            		[noImageMSG]="'No Images with this item'"
            		(recordSelected)="goToImage($event)"
            		(handleEndofImageSet)="getRelatedImagesNextPage()"></app-image-carousel>
        		</td>
      		</tr>
			<tr class="tableRow">
				<td valign="top" style="margin:0;padding:0">
					<label>Specification Text</label><br />
					<ejs-richtexteditor [toolbarSettings]="rtfViewTools" (actionComplete)="handleRTFActions($event)"
						[height]="RTFHeight" [readonly]="true" [enableHtmlEncode]="true" [enablePersistence]="false"
						id="viewRTE" [value]="viewModel.specifications"></ejs-richtexteditor>
					<br />
				</td>
			</tr>
			<tr class="tableRow">
				<td >
					<label>Specification Categories</label><br />
					<div class="component-holder">
						<app-qmcategories-display
							[columns]="(canEdit ? ['Category','Created date and time', 'Created by user'] : [])"
							[data]="getCategoriesArray()" [isAdmin]="canEdit" [editMode]="false">
						</app-qmcategories-display>
					</div>
				</td>
			</tr>
			<tr class="tableRow">
				<td valign="top" >
					<label>Item-to-Item References</label><br />
					<div class="component-holder">
						<app-qmmanuals-display (linkClick)="enterViewMode($event)" [data]="getRefQMArrays()"
							[isAdmin]="isAdmin" [editable]="false"
							[columns]="(isAdmin ? ['Item Name', 'Created Date Time', 'Created By'] : [])">
						</app-qmmanuals-display>
					</div>
				</td>
			</tr>
		</tbody>
	</table>
	<hr />
	<div class="recordInfo" *ngIf="canEdit && ((addMode && model.uid > 0) || viewModel.uid > 0)" style="margin-bottom: 100px;">
		<div class="col-auto">
			Id: {{viewModel.uid}}; Created {{ viewModel.createdDateTime | date:'MM/dd/yyyy h:mm a' }} by {{
			(viewModel.createdByUser ? viewModel.createdByUser : ' user unknown') }};
			Last modified {{ (viewModel.lastModifiedByUser ? ( (viewModel.lastModifiedDateTime | date:'MM/dd/yyyy h:mm a') +
			' by ' + viewModel.lastModifiedByUser) : 'N/A' )}}
		</div>
		<div class="col-auto" *ngIf="isAdmin">Guid: {{ viewModel.guid }}</div>
		<div class="col-auto" *ngIf="isAdmin">
			<button class="btn btn-sm btn-link" (click)="sbCmpMsg.recordHistoryEmitter.emit(viewModel.guid)">
				<i class="fal fa-history me-1"></i>
				Record History
			</button>
		</div>
	</div>
	<div style="height: 10em;"></div>

	<!--<app-recent-thumbnails *ngIf="relatedImages && relatedImages.length > 0" (recordSelected)="GoToImage($event)"
		[qmManualName]="viewModel.itemName" [imageCollection]="relatedImages"></app-recent-thumbnails>-->

</div>